import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import ImageModule from "../../modules/image_module";

import "./FeaturedLogo.scss"

const ClientLogo = ({Module}) => {

    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        centerMode:false,
        autoplay:true,
        autoplaySpeed:3000,
        speed: 3000,
        variableWidth: true,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    dots: true,
                },
            },

        ],
    };

    return (<>
        {Module?.client_logos_component?.length > 0 &&
        <section className={`features logo_wrapper`}>
            <Container>
                <Row>
                    <Col>
                        <h2>{Module.title ? Module.title : "Featured In"}</h2>
                        <div className="brand-wrap">
                            <Slider {...settings}>
                                {Module?.client_logos_component?.map((item, index) =>{
                                    if(item.client_logo){
                                        return(
                                            
                                                <a href={item.link ? item.link : "javascript:;"} target={item.link ? "_blank" : "_self"}>
                                                    <ImageModule ImageSrc={item.client_logo} />
                                                </a>
                                            
                                        )
                                    }                    
                                })}
                            </Slider>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
        }
    </>)
}
export default ClientLogo;